<h2 mat-dialog-title class="dialog-title">
    <span>{{Title}}</span>
    <div class="mddialog_header_close">
        <button [mat-dialog-close]="true" class="fa fa-times" style="font-size: xx-large;border-width:inherit;background-color: #000000; color: #ffffff;margin-top: -10px; "></button>
    </div>
</h2>

<div>
    <div *ngIf="fail__log_msg" style="color:red ;padding-left: 5%">
        {{failLog}}
    </div> 
</div>
<mat-dialog-content style="margin-top: 40px;">
    <form #deltDataForm="ngForm" style="text-align: center;">
        <h1 style="font-size: 15px;">Do you want to Remove Access?</h1>
<!--        
        <div *ngIf="fail__log_msg" style="color:red ;">{{failLog}}</div> -->
    

            <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                        <button type="button" mat-raised-button color="primary" style="background: #000000;color:#ffffff;font-weight: bold; margin-top: 6%;font-family: 'Open Sans', sans-serif;" (click)="delete()">YES</button>
                    </div>
                 </div>
                 <div class="col-md-6">
                    <div class="form-group">
                        <button type="button" [mat-dialog-close]="true" mat-raised-button color="primary" style="background: #000000;color:#ffffff;font-weight: bold; margin-top: 6%;font-family: 'Open Sans', sans-serif;">NO</button>
                    </div>
                    </div>
             
            </div>
      
    </form>
</mat-dialog-content>